import { render } from "./LoadingSvg.vue?vue&type=template&id=4dc98f22&scoped=true"
import script from "./LoadingSvg.vue?vue&type=script&lang=js"
export * from "./LoadingSvg.vue?vue&type=script&lang=js"

import "./LoadingSvg.vue?vue&type=style&index=0&id=4dc98f22&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dc98f22"]])

export default __exports__